/* eslint-disable eslint-comments/disable-enable-pair, react/jsx-max-depth, react/jsx-no-literals, react/jsx-handler-names, max-lines-per-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import OutsideElementClickCatcher from 'src/components/OutsideElementClickCatcher';
import styles from 'src/components/LocationRadius.scss';

import MenuDown from '@mdi/svg/svg/menu-down.svg';


const keyCodes = {
  up: 38,
  down: 40
};

class LocationRadius extends Component {
  openRadiusSelector = () => {
    const { actions: { setRadiusOpen } } = this.props;
    setRadiusOpen(true);
  };

  closeRadiusSelector = () => {
    const { radiusOpen, actions: { setRadiusOpen } } = this.props;
    if (radiusOpen) {
      setRadiusOpen(false);
    }
  };

  handleKeyPress = (event) => {
    const {
      maxValue, maxValueForSmallSteps, smallRadiusStep, largeRadiusStep, value, actions
    } = this.props;

    if (event.keyCode === keyCodes.up) {
      event.preventDefault();
      const radiusStep = value >= maxValueForSmallSteps ? largeRadiusStep : smallRadiusStep;

      actions.setRadiusValue(Math.min(maxValue, value + radiusStep));
    }

    if (event.keyCode === keyCodes.down) {
      event.preventDefault();
      const radiusStep = value > maxValueForSmallSteps ? largeRadiusStep : smallRadiusStep;

      actions.setRadiusValue(Math.max(0, value - radiusStep));
    }
  };

  selectRadius = (radius) => {
    const { actions: { setRadiusValue, setRadiusOpen } } = this.props;

    setRadiusValue(radius);
    setRadiusOpen(false);
  };

  calculateRadiusSteps = () => {
    const {
      maxValue,
      maxValueForSmallSteps,
      smallRadiusStep,
      largeRadiusStep
    } = this.props;

    const smallStepsRadiusList = new Array(
      (maxValueForSmallSteps / smallRadiusStep) + 1
    ).fill(null)
      .map((step, index) => index * smallRadiusStep);

    const largeStepsRadiusList = new Array(
      (maxValue - maxValueForSmallSteps) / largeRadiusStep
    ).fill(null)
      .map((step, index) => maxValueForSmallSteps + ((index + 1) * largeRadiusStep));

    return [
      ...smallStepsRadiusList, ...largeStepsRadiusList
    ];
  };

  render() {
    const { value, radiusOpen, radiusDisabled } = this.props;
    const radiusSteps = this.calculateRadiusSteps();

    const rangeListItems = radiusSteps
      .map(step => (
        <li
          key={ String(step) }
          data-test="radius-step"
          value={ step }
        >
          <button
            aria-hidden={ !radiusOpen }
            className={
              classNames({
                [styles['radius__options-list-trigger--current']]: value === step
              })
            }
            data-test="button-radius-select"
            onClick={ this.selectRadius.bind(this, step) }
            styleName="radius__options-list-trigger"
            type="button"
          >
            {/* eslint-disable-next-line react/jsx-no-literals */ }
            {`+ ${step} km`}
          </button>
        </li>
      ));

    return (
      <OutsideElementClickCatcher callback={ this.closeRadiusSelector }>
        <div
          className={
            classNames({
              [styles['radius--filled']]: !radiusDisabled,
              [styles['radius--disabled']]: radiusDisabled
            }) }
          data-test="radius"
          styleName="radius"
        >
          <div
            className={
              classNames({
                [styles['radius__options--open']]: radiusOpen
              })
            }
            data-test="radius-options"
            styleName="radius__options"
          >
            <button
              data-test="radius-input"
              disabled={ radiusDisabled }
              onClick={ this.openRadiusSelector }
              onKeyDown={ this.handleKeyPress }
              styleName="radius__field"
              type="button"
            >
              { `+ ${value} km` }
            </button>
            <input name="rd" type="hidden" value={ value } />
            <MenuDown styleName="radius__wrap-down" viewBox="0 0 24 24" />
            <span styleName="radius__field-bar" />
            <ul
              data-test="radius-list"
              styleName="radius__options-list"
            >
              {rangeListItems}
            </ul>
          </div>
          <span styleName="radius__field-bar" />
        </div>
      </OutsideElementClickCatcher>
    );
  }
}

LocationRadius.propTypes = {
  actions: PropTypes.shape({
    setRadiusOpen: PropTypes.func,
    setRadiusValue: PropTypes.func
  }),
  largeRadiusStep: PropTypes.number,
  maxValue: PropTypes.number,
  maxValueForSmallSteps: PropTypes.number,
  radiusDisabled: PropTypes.bool,
  radiusOpen: PropTypes.bool,
  smallRadiusStep: PropTypes.number,
  value: PropTypes.number
};

LocationRadius.defaultProps = {
  actions: {
    setRadiusValue: () => {
    },
    setRadiusOpen: () => {
    }
  },
  largeRadiusStep: 25,
  maxValue: 100,
  maxValueForSmallSteps: 50,
  radiusDisabled: false,
  radiusOpen: false,
  smallRadiusStep: 5,
  value: 0
};

export default LocationRadius;
